// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3a8su","signatureBlock":"Footer_signatureBlock__2gzIt","signature":"Footer_signature__2MyhE"};